import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - dodaj token na svaki zahtev
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - globalno hendlovanje grešaka
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const url = error.config?.url || '';
      const isAuthEndpoint = url.startsWith('/auth/') || url.includes('/auth/');
      switch (error.response.status) {
        case 401:
          // Skip token cleanup for auth endpoints — login itself returns 401
          // for wrong credentials; let the caller show its own error message.
          if (!isAuthEndpoint) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            window.dispatchEvent(new Event('auth-changed'));
          }
          break;
        case 403:
          console.error('Nemate pristup ovom resursu.');
          break;
        case 500:
          console.error('Greška na serveru.');
          break;
        default:
          break;
      }
    }
    return Promise.reject(error);
  }
);

export default api;
